module.exports = __webpack_public_path__ + "static/img/6.17098bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/zh/6.png
// module id = epgN
// module chunks = 0